import { generateAddress, toChecksumAddress } from 'ethereumjs-util';

export default function calculateContractAddress(creatorAddress, nonce) {
    var addressBuffer = generateAddress(creatorAddress, nonce);
    var address = addressBuffer.toString('hex');
    return toChecksumAddress(address);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/eth-crypto/dist/es/calculate-contract-address.js
// module id = 1291
// module chunks = 0